var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('Header', {
    attrs: {
      "meta": _vm.meta,
      "page-title": _vm.moduleConfig.page_title,
      "page-image": _vm.moduleConfig.page_image,
      "page-kv-image": _vm.moduleConfig.page_kv_image,
      "header-section": _vm.moduleConfig.header_section
    }
  }), _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "scratch p-4 text-center"
  }, [_c('h1', {
    staticClass: "text-center py-5"
  }, [_vm._v("刮刮卡")]), _c('div', {
    staticClass: "position-relative m-auto",
    staticStyle: {
      "height": "300px",
      "width": "300px"
    }
  }, [_c('div', {
    staticClass: "award d-flex justify-content-center align-items-center"
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.$route.query.act && _vm.$route.query.act == 1 ? "恭喜中獎" : "未中獎") + " ")])]), _c('canvas', {
    ref: "cover",
    staticClass: "cover",
    attrs: {
      "id": "cover",
      "width": "300",
      "height": "300"
    },
    on: {
      "mousedown": _vm.eventDown,
      "mouseup": _vm.eventUp,
      "mousemove": _vm.eventMove,
      "touchstart": _vm.eventDown,
      "touchend": _vm.eventUp,
      "touchmove": _vm.eventMove
    }
  })])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }